import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Modal, ContactCard, Button } from 'hosman-material';
import { S_Pen, S_TrashCan, S_Info } from 'hosman-material';

import { updateSalesUser, updateSalesUserToRemove, removeSalesUser } from '../../../../../../../../reducers/SellerApp/salesUsersSlice';

const SalesUsersList = () => {
  const { sale } = useSelector((state) => state.sellerSales);
  const { signatories, saleContacts, isRemoving, salesUserToRemove } = useSelector((state) => state.sellerSalesUsers);
  const dispatch = useDispatch();

  const handleUpdate = (saleUser) => {
    dispatch(updateSalesUser({
      id: saleUser.id,
      kind: saleUser.kind,
      signatory: saleUser.signatory,
      user_id: saleUser.user.id,
      active: saleUser.user.active,
      first_name: saleUser.user.first_name,
      last_name: saleUser.user.last_name,
      civility: saleUser.user.civility,
      email: saleUser.user.email,
      phone_country_code: saleUser.user.phone_country_code || 'FR',
      phone_number: saleUser.user.phone_number
    }))
  }

  return (
    <div className='grid grid-cols-1 md:grid-cols-3 gap-8'>
      {signatories.concat(saleContacts).map((saleUser, index) => {
        return (
          <div key={saleUser.id} className='relative w-min'>
            <ContactCard
              email={saleUser.user.email}
              name={`${saleUser.user.first_name} ${saleUser.user.last_name}`}
              phone={saleUser.user.phone_number.replace('+33', '0')}
            />

            {!saleUser.signatory &&
              <div className='absolute top-12 right-0 md:-top-3 md:right-3 flex flex-col md:flex-row gap-2'>
                <div className='flex items-center justify-center border bg-ih-purple-10 text-ih-indigo w-12 h-12 md:w-8 md:h-8 rounded-full cursor-pointer'>
                  <FontAwesomeIcon icon={S_Pen} onClick={() => handleUpdate(saleUser)} />
                </div>

                <div className='flex items-center justify-center border bg-ih-red-10 text-ih-red-80 w-12 h-12 md:w-8 md:h-8 rounded-full cursor-pointer'>
                  <FontAwesomeIcon icon={S_TrashCan} onClick={() => dispatch(updateSalesUserToRemove(saleUser))} />
                </div>
              </div>
            }
          </div>
        )
      })}

      {salesUserToRemove &&
        <Modal isOpen closeModal={() => dispatch(updateSalesUserToRemove(null))}>
          <div className='flex flex-col items-center gap-6 p-8'>
            <div className='flex items-center justify-center bg-ih-red-20 text-ih-red-80 w-8 h-8 rounded-full'>
              <FontAwesomeIcon icon={S_Info} />
            </div>

            <p className='h3 text-ih-indigo'>Êtes-vous sûr de vouloir supprimer le contact {salesUserToRemove.user.first_name} {salesUserToRemove.user.last_name} ?</p>
            
            <div className='flex flex-col md:flex-row md:justify-center gap-3'>
              <Button label='Annuler' type='tertiary' onClick={() => dispatch(updateSalesUserToRemove(null))} />
              <Button label='Confirmer' onClick={()  => dispatch(removeSalesUser({ saleId: sale.id, salesUserId: salesUserToRemove.id }))} isLoading={isRemoving} />
            </div>
          </div>
        </Modal>
      }
    </div>
  );
}

export default SalesUsersList;
